module.exports = __webpack_public_path__ + "img/detBannerGreen.0401b811.jpg";